import React from "react";

import { useBotbRAFContext } from "../context";
import ChevronsRightIcon from "@/app/shared-components/icons/ChevronsRightIcon";

export const ReferAFriendOnboarding = (): React.ReactNode => {
  const { rafStatus, loading, setFTU, preSubscriptionData, userName } = useBotbRAFContext();
  // const vidRef = useRef(null);
  // useEffect(() => {
  //     vidRef.current.pause();
  //     setTimeout(() => {
  //         vidRef.current.play();
  //     }, 3000);
  // }, []);

  const loader1 = "h-full bg-primary rounded-full w-0 [animation:loader1_2s_ease_0.5s_forwards]";
  const loader2 = "h-full bg-primary rounded-full w-0 [animation:loader1_7s_ease_2.5s_forwards]";

  const stepOneDesc = "-translate-x-full [animation:slideText_2s_ease_0.5s_forwards] px-4 mb-16 lg:mb-8";
  const mainShift =
    "text-dark-1 text-xl leading-7.5 font-medium overflow-hidden w-full lg:min-h-full lg:grow relative z-[1] [animation:fadeOut_0.5s_ease-in-out_2.5s_forwards]";

  const secondStepDesc = "relative opacity-0 -z-[1] [animation:fadeIn_1s_ease-in-out_3s_forwards]";
  const styledAnimated_1 = "relative opacity-0 -z-[1] [animation:fadeIn_1s_ease-in-out_4s_forwards]";
  const styledAnimated_2 = "relative opacity-0 -z-[1] [animation:fadeIn_1s_ease-in-out_5s_forwards]";
  const styledAnimated_3 = "relative opacity-0 -z-[1] [animation:fadeIn_1s_ease-in-out_6s_forwards]";

  const buttonFirst =
    "mt-auto text-center w-full px-4 h-10 relative overflow-hidden lg:mb-4 -z-[1] opacity-0 [animation:fadeIn_2s_ease-in-out_7s_forwards]";
  const buttonSecond = "translate-y-full [animation:slideButton_2s_ease-in-out_7s_forwards]";

  const onboardingText = {
    nickNameLabel: "Congratulation",
    nickNameValue: `${userName}`,
    stepOneDesc: "You can now share BOTB Pass with friends — and you’ll both earn rewards when they join.",
    stepTwoTitle: "What you need to do:",
    recTitle: "Invite your friends to join BOTB Pass",
    recDesc: `You can invite up to ${loading ? "" : rafStatus.maximumInvites} friends`,
    friendTitle: "Your friend subscribes",
    friendDesc: "They join BOTB Pass with an active subscription.",
    bothTitle: "You both win",
    bothDesc: `You receive £${loading ? "" : rafStatus.cashPerInvite}, and they receive ${preSubscriptionData?.offer?.description ? preSubscriptionData?.offer?.description : ""}.`,
    bottomButton: "Get started",
  };

  return (
    <>
      {/*#1*/}
      <div
        data-name={"ReferAFriendOnboarding"}
        className={
          "font-jost flex items-center flex-col h-full min-h-full grow pb-6 lg:w-[540px] lg:max-w-[332px] lg:mx-auto"
        }>
        {/*PROGRESS BAR START*/}
        <div
          data-name={"progressBar-RAF"}
          className={"grid grid-cols-2 mb-6 max-lg:px-2 w-full gap-2 relative z-[3] lg:pt-4 lg:gap-2.5"}>
          <div className={"bg-orange-2 h-1 flex-auto rounded-full"}>
            <div className={loader1} />
          </div>
          <div className={"bg-orange-2 h-1 flex-auto rounded-full"}>
            <div className={loader2} />
          </div>
        </div>
        {/*PROGRESS BAR END*/}

        {/*<div*/}
        {/*    data-name={"videoContainer-RAF"}*/}
        {/*    className={*/}
        {/*        "fixed-theme inset-0 z-[1] size-full [animation:fadeOut_1s_ease-in-out_5s_forwards] lg:absolute lg:text-center lg:w-[600px] lg:h-[640px] bg-yellow-1"*/}
        {/*    }>*/}
        {/*    <video*/}
        {/*        ref={vidRef}*/}
        {/*        className={"object-cover w-full h-dvh lg:w-[600px] lg:h-[640px]"}*/}
        {/*        autoPlay*/}
        {/*        playsInline*/}
        {/*        muted>*/}
        {/*        <source src={"/images/refer-a-friend/user_video_3.mp4"} type={"video/mp4"} />*/}
        {/*        <track kind={"captions"} src={""} srcLang={"en"} label={"English"} default />*/}
        {/*    </video>*/}
        {/*</div>*/}

        {/*<div*/}
        {/*    className={*/}
        {/*        "fixed-theme inset-0 z-0 size-full bg-no-repeat bg-cover lg:absolute lg:text-center lg:w-[600px] lg:h-[640px]"*/}
        {/*    }*/}
        {/*     style={{ backgroundImage: "url(/images/refer-a-friend/step_two_bg.png)" }}*/}
        {/*/>*/}

        <div data-name={"firstStep"} className={"overflow-hidden relative size-full min-h-full grow"}>
          {/*FIRST STEP START*/}
          <div className={"size-full absolute top-0 left-0"}>
            <div className={mainShift}>
              <div className={"px-4"}>
                {onboardingText.nickNameLabel} {onboardingText.nickNameValue}
              </div>
              <div className={stepOneDesc}>{onboardingText.stepOneDesc}</div>
              {/*<div*/}
              {/*    className={"-translate-x-full [animation:slideText_0.5s_ease_2s_forwards] flex-center w-full"}>*/}
              {/*    <div className={"size-[278px] rounded-2xl overflow-hidden"}>*/}
              {/*        <video*/}
              {/*            ref={vidRef}*/}
              {/*            className={"object-cover"}*/}
              {/*            autoPlay*/}
              {/*            playsInline*/}
              {/*            muted>*/}
              {/*            <source src={"/images/refer-a-friend/placeholder-video.mp4"}*/}
              {/*                    type={"video/mp4"}/>*/}
              {/*            <track kind={"captions"} src={""} srcLang={"en"} label={"English"} default/>*/}
              {/*        </video>*/}
              {/*    </div>*/}
              {/*</div>*/}
            </div>
          </div>
          {/*FIRST STEP END*/}

          {/*SECOND STEP START*/}
          <div data-name={"secondStep"} className={"size-full absolute top-0 left-0 flex flex-col"}>
            {/*#animation default*/}
            <div className={`text-dark-1 text-xl font-medium mb-6 w-full px-4 relative z-[2] ${secondStepDesc}`}>
              {onboardingText.stepTwoTitle}
            </div>

            {/*#animation 1*/}
            <div className={`flex items-center gap-1.5 lg:gap-3 mx-4 mb-2 ${styledAnimated_1}`}>
              {/*LEFT*/}
              <div className={"relative size-10 lg:size-12 min-w-10 lg:min-w-12 rounded-full flex-center bg-gray-11"}>
                <div
                  className={
                    "absolute -top-[5px] -left-[5px] flex-center rounded-full bg-primary size-4.5 text-white text-xs leading-4 text-center"
                  }>
                  1
                </div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  className={"size-5 lg:size-6"}>
                  <g clip-path="url(#clip0_51319_3540)">
                    <path
                      d="M6.66602 5.83333C6.66602 6.71739 7.0172 7.56524 7.64233 8.19036C8.26745 8.81548 9.11529 9.16667 9.99935 9.16667C10.8834 9.16667 11.7313 8.81548 12.3564 8.19036C12.9815 7.56524 13.3327 6.71739 13.3327 5.83333C13.3327 4.94928 12.9815 4.10143 12.3564 3.47631C11.7313 2.85119 10.8834 2.5 9.99935 2.5C9.11529 2.5 8.26745 2.85119 7.64233 3.47631C7.0172 4.10143 6.66602 4.94928 6.66602 5.83333Z"
                      stroke="black"
                      stroke-opacity="0.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M13.332 15.832H18.332"
                      stroke="black"
                      stroke-opacity="0.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M15.832 13.332V18.332"
                      stroke="black"
                      stroke-opacity="0.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M5 17.5V15.8333C5 14.9493 5.35119 14.1014 5.97631 13.4763C6.60143 12.8512 7.44928 12.5 8.33333 12.5H11.6667"
                      stroke="black"
                      stroke-opacity="0.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_51319_3540">
                      <rect width="20" height="20" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              {/*RIGHT*/}
              <div className={"w-full"}>
                <div className={"text-dark-1 text-sm lg:text-lg leading-5 lg:leading-6 font-medium"}>
                  {onboardingText.recTitle}
                </div>
                <div className={"text-gray-1 text-sm lg:text-base leading-4 lg:leading-5.5 font-normal"}>
                  {onboardingText.recDesc}
                </div>
              </div>
            </div>
            <div className={`w-0.5 h-6 mb-2 ml-[35px] rounded-full bg-gray-11 ${styledAnimated_1}`}></div>

            {/*#animation 2*/}
            <div className={`flex items-center gap-4 mx-4 mb-2 ${styledAnimated_2}`}>
              {/*LEFT*/}
              <div className={"relative size-10 lg:size-12 min-w-10 lg:min-w-12 rounded-full flex-center bg-gray-11"}>
                <div
                  className={
                    "absolute -top-[5px] -left-[5px] flex-center rounded-full bg-primary size-4.5 text-white text-xs leading-4 text-center"
                  }>
                  2
                </div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  className={"size-5 lg:size-6"}>
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M11.0048 10V6.25C11.0048 5.56 10.4448 5 9.75476 5C9.06476 5 8.50476 5.56 8.50476 6.25V12.5L6.81143 11.9358C6.31726 11.7708 5.77226 11.9 5.4031 12.2683C4.8306 12.8408 4.87393 13.78 5.49476 14.2983L8.87393 17.1142C9.17476 17.3633 9.55226 17.5 9.94143 17.5H13.6998C14.5406 17.5 15.2489 16.8742 15.3539 16.04L15.8064 12.4208C15.9173 11.5333 15.3081 10.7175 14.4264 10.57L11.0048 10Z"
                    stroke="#797979"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M6 8H4C2.89543 8 2 7.10457 2 6V4C2 2.89543 2.89543 2 4 2H14C15.1046 2 16 2.89543 16 4V6C16 7.10457 15.1046 8 14 8H12.5M4 5L5 6L6.5 3.5"
                    stroke="#797979"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              {/*RIGHT*/}
              <div className={"w-full"}>
                <div className={"text-dark-1 text-sm lg:text-lg leading-5 lg:leading-6 font-medium"}>
                  {onboardingText.friendTitle}
                </div>
                <div className={"text-gray-1 text-sm lg:text-base leading-4 lg:leading-5.5 font-normal"}>
                  {onboardingText.friendDesc}
                </div>
              </div>
            </div>
            <div className={`w-0.5 h-6 mb-2 ml-[35px] rounded-full bg-gray-11 ${styledAnimated_2}`}></div>

            {/*#animation 3*/}
            <div className={`flex items-center gap-4 mx-4 mb-2 ${styledAnimated_3}`}>
              {/*LEFT*/}
              <div className={"relative size-10 lg:size-12 min-w-10 lg:min-w-12 rounded-full flex-center bg-gray-11"}>
                <div
                  className={
                    "absolute -top-[5px] -left-[5px] flex-center rounded-full bg-primary size-4.5 text-white text-xs leading-4 text-center"
                  }>
                  3
                </div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  className={"size-5 lg:size-6"}>
                  <path
                    d="M5.105 11.5L2.5 14.1667L4.58333 15.4167L5.83333 17.5L9.0825 14.0875"
                    stroke="#797979"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M10.918 14.0875L14.1671 17.5L15.4171 15.4167L17.5005 14.1667L14.8955 11.5"
                    stroke="#797979"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M14.1241 4.20854C16.4022 6.4866 16.4022 10.1801 14.1241 12.4581C11.8461 14.7362 8.15262 14.7362 5.87456 12.4581C3.5965 10.1801 3.5965 6.4866 5.87456 4.20854C8.15262 1.93049 11.8461 1.93049 14.1241 4.20854"
                    stroke="#797979"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.99966 10.4867L11.4972 11.2734C11.7888 11.4267 12.1297 11.1792 12.0738 10.8542L11.788 9.18675L12.9997 8.00674C13.2355 7.77674 13.1055 7.37591 12.7797 7.32841L11.1055 7.08508L10.3572 5.56758C10.2113 5.27174 9.7905 5.27174 9.64466 5.56758L8.89633 7.08508L7.22133 7.32924C6.8955 7.37674 6.7655 7.77758 7.00133 8.00758L8.213 9.18758L7.92716 10.8551C7.87133 11.1801 8.21216 11.4276 8.50383 11.2742L10.0013 10.4876H9.99966V10.4867Z"
                    stroke="#797979"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              {/*RIGHT*/}
              <div className={"w-full"}>
                <div className={"text-dark-1 text-sm lg:text-lg leading-5 lg:leading-6 font-medium"}>
                  {onboardingText.bothTitle}
                </div>
                <div className={"text-gray-1 text-sm lg:text-base leading-4 lg:leading-5.5 font-normal"}>
                  {onboardingText.bothDesc}
                </div>
              </div>
            </div>

            {/*-z-[1] opacity-0 [animation:fadeIn_1s_ease-in-out_12s_forwards]*/}
            <div data-name={"buttonBottom"} className={buttonFirst}>
              {/*[animation:slideButton_1s_ease-in-out_12s_forwards]*/}
              <div className={buttonSecond}>
                <button
                  type={"button"}
                  onClick={setFTU}
                  className={"theme-btn theme-btn-primary w-full uppercase lg:mx-auto lg:flex"}>
                  {onboardingText.bottomButton}
                  <ChevronsRightIcon variant={2} className={"size-4 lg:size-6 shrink-0"} />
                </button>
              </div>
            </div>
          </div>
          {/*SECOND STEP END*/}
        </div>
      </div>
    </>
  );
};
